import { render, staticRenderFns } from "./entry_orange.vue?vue&type=template&id=63136c70&scoped=true"
import script from "./entry_orange.vue?vue&type=script&lang=js"
export * from "./entry_orange.vue?vue&type=script&lang=js"
import style0 from "./entry_orange.vue?vue&type=style&index=0&id=63136c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63136c70",
  null
  
)

export default component.exports